import { CheckCircle2, X } from "lucide-react";

const LABELS = {
  fonsterputs: "Fönsterputs",
  solpaneltvatt: "Solpaneltvätt",
  altantvatt: "Altantvätt",
  marktvatt: "Marktvätt",
  annat: "Annat",
};

/** Live booking summary content — main service and add-on visually separated. No prices. */
export const BookingSummary = ({ services, fonsterputsLevel, mellanFonstren, onRemoveMellan }) => (
  <div data-testid="booking-summary">
    <p className="text-xs font-semibold uppercase tracking-[0.22em] text-brand-blue">Din bokning</p>
    {services.length === 0 ? (
      <p className="mt-3 text-sm text-slate-500 leading-relaxed">Välj en eller flera tjänster så bygger vi din offert här.</p>
    ) : (
      <ul className="mt-3.5 space-y-3">
        {services.map((s) => (
          <li key={s} className="text-sm">
            <span className="flex items-center gap-2 font-semibold text-brand-ink">
              <CheckCircle2 className="h-4 w-4 text-brand-blue shrink-0" /> {LABELS[s] || s}
            </span>
            {s === "fonsterputs" && fonsterputsLevel && (
              <span className="mt-1.5 ml-6 flex flex-wrap items-center gap-1.5">
                <span className="text-xs font-semibold bg-brand-ice text-brand-blue px-2.5 py-1 rounded-md" data-testid="summary-level">
                  {fonsterputsLevel}
                </span>
                {mellanFonstren && (
                  <span className="inline-flex items-center gap-1 text-xs font-semibold bg-success/10 text-success px-2.5 py-1 rounded-md" data-testid="summary-mellan">
                    + Mellan fönstren
                    {onRemoveMellan && (
                      <button
                        type="button"
                        onClick={onRemoveMellan}
                        data-testid="summary-remove-mellan"
                        aria-label="Ta bort tillvalet Mellan fönstren"
                        className="h-4 w-4 rounded-full hover:bg-success/20 flex items-center justify-center transition-colors"
                      >
                        <X className="h-3 w-3" />
                      </button>
                    )}
                  </span>
                )}
              </span>
            )}
          </li>
        ))}
      </ul>
    )}
  </div>
);

export default BookingSummary;
